"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// all keys stored in the cache by this SDK will be prefixed with this value
var CACHE_PREFIX = 'cmx:'; // cached for 1 minute

var CACHE_DURATION_MIN = 1;

function SDK(baseUrl, fetch, cacheInterface, companyId) {
  // Private
  function _fetchJson(url, options) {
    return new Promise(function ($return, $error) {
      var res, data, text;

      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'Content-Type', 'application/json'));
      }

      return fetch("".concat(baseUrl).concat(url), options).then(function ($await_3) {
        res = $await_3;

        if (res.ok) {
          return res.json().then($return, $error);
        } else {
          if (res.headers.get('Content-Type').indexOf('application/json') !== -1) {
            return res.json().then(function ($await_5) {
              data = $await_5;
              return $error(data);
            }.$asyncbind(this, $error), $error);
          }

          return res.text().then(function ($await_6) {
            text = $await_6;
            return $error(text);
          }.$asyncbind(this, $error), $error);
        }

        return $return();
      }.$asyncbind(this, $error), $error);
    });
  }

  var getKey = function getKey(key) {
    if (companyId) {
      return "".concat(CACHE_PREFIX).concat(companyId, ":").concat(key);
    }

    return "".concat(CACHE_PREFIX).concat(key);
  };

  var _cacheGet = function _cacheGet(key) {
    return cacheInterface.get(getKey(key));
  };

  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set(getKey(key), value, ttl);
  };

  var _cacheClearByKey = function _cacheClearByKey(key) {
    return cacheInterface.clearByKey(getKey(key));
  };

  var _cacheClearByKeyStartsWith = function _cacheClearByKeyStartsWith(key) {
    return cacheInterface.clearByKeyStartsWith(getKey(key));
  };

  var CACHE_KEY_LOCALES = 'locales';
  var CACHE_KEY_PROJECTS = 'projects';
  var CACHE_KEY_KEYS = 'keys';
  var CACHE_KEY_STRINGS = 'strings';
  var CACHE_KEY_BUNDLES = 'bundles';
  var CACHE_KEY_HIERARCHY = 'hierarchy';
  var CACHE_KEY_COMPANYLOCALES = 'companyLocales';
  var CACHE_KEY_ALL_COMPANYLOCALES = 'allCompanyLocales';
  return {
    getAllLocales: function getAllLocales() {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet(CACHE_KEY_LOCALES);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson('/locales').then(function ($await_7) {
          response = $await_7;
          return $return(_cacheSet(CACHE_KEY_LOCALES, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    createLocale: function createLocale(localeDefinition) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson('/locales', {
          method: 'POST',
          body: JSON.stringify(localeDefinition)
        }).then(function ($await_8) {
          response = $await_8;

          _cacheClearByKey(CACHE_KEY_LOCALES);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    updateLocale: function updateLocale(localeCode, localeDefinition) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/locales/".concat(localeCode), {
          method: 'POST',
          body: JSON.stringify(localeDefinition)
        }).then(function ($await_9) {
          response = $await_9;

          _cacheClearByKey(CACHE_KEY_LOCALES);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteLocale: function deleteLocale(localeCode) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/locales/".concat(localeCode), {
          method: 'DELETE'
        }).then(function ($await_10) {
          response = $await_10;

          _cacheClearByKey(CACHE_KEY_LOCALES);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getAllCompanyLocales: function getAllCompanyLocales() {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet(CACHE_KEY_ALL_COMPANYLOCALES);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson('/companyLocales').then(function ($await_11) {
          response = $await_11;
          return $return(_cacheSet(CACHE_KEY_ALL_COMPANYLOCALES, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    getCompanyLocalesById: function getCompanyLocalesById(companyId) {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet(CACHE_KEY_COMPANYLOCALES);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson("/companyLocales/".concat(companyId)).then(function ($await_12) {
          response = $await_12;
          return $return(_cacheSet(CACHE_KEY_COMPANYLOCALES, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    createCompanyLocales: function createCompanyLocales(locales) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson('/companyLocales', {
          method: 'POST',
          body: JSON.stringify({
            locales: locales
          })
        }).then(function ($await_13) {
          response = $await_13;

          _cacheClearByKey(CACHE_KEY_COMPANYLOCALES);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteCompanyLocale: function deleteCompanyLocale(companyId) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/companyLocales/".concat(companyId), {
          method: 'DELETE'
        }).then(function ($await_14) {
          response = $await_14;

          _cacheClearByKey(CACHE_KEY_COMPANYLOCALES);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getAllProjects: function getAllProjects() {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet(CACHE_KEY_PROJECTS);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson('/projects').then(function ($await_15) {
          response = $await_15;
          return $return(_cacheSet(CACHE_KEY_PROJECTS, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    getProject: function getProject(projectName) {
      return new Promise(function ($return, $error) {
        var cacheKey, cached, response;
        cacheKey = "".concat(CACHE_KEY_PROJECTS, "-").concat(projectName);
        cached = _cacheGet(cacheKey);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson("/projects/".concat(projectName)).then(function ($await_16) {
          response = $await_16;
          return $return(_cacheSet(cacheKey, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    createProject: function createProject(projectDefinition) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson('/projects', {
          method: 'POST',
          body: JSON.stringify(projectDefinition)
        }).then(function ($await_17) {
          response = $await_17;

          _cacheClearByKey(CACHE_KEY_PROJECTS);

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    updateProject: function updateProject(projectName, projectDefinition) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName), {
          method: 'POST',
          body: JSON.stringify(projectDefinition)
        }).then(function ($await_18) {
          response = $await_18;

          _cacheClearByKey(CACHE_KEY_PROJECTS);

          _cacheClearByKey("".concat(CACHE_KEY_PROJECTS, "-").concat(projectName));

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteProject: function deleteProject(projectName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName), {
          method: 'DELETE'
        }).then(function ($await_19) {
          response = $await_19;

          _cacheClearByKey(CACHE_KEY_PROJECTS);

          _cacheClearByKey("".concat(CACHE_KEY_PROJECTS, "-").concat(projectName));

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKey("".concat(CACHE_KEY_HIERARCHY, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createHierarchy: function createHierarchy(projectName, Hierarchy) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson('/projects/hierarchy/save', {
          method: 'POST',
          body: JSON.stringify({
            projectName: projectName,
            Hierarchy: Hierarchy
          })
        }).then(function ($await_20) {
          response = $await_20;

          _cacheClearByKey("".concat(CACHE_KEY_HIERARCHY, "-").concat(projectName));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getHierarchy: function getHierarchy(projectName) {
      return new Promise(function ($return, $error) {
        var cacheKey, cached, response;
        cacheKey = "".concat(CACHE_KEY_HIERARCHY, "-").concat(projectName);
        cached = _cacheGet(cacheKey);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson("/projects/".concat(projectName, "/hierarchy")).then(function ($await_21) {
          response = $await_21;
          return $return(_cacheSet(cacheKey, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    removeHierarchy: function removeHierarchy(projectName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/hierarchy"), {
          method: 'DELETE'
        }).then(function ($await_22) {
          response = $await_22;

          _cacheClearByKey("".concat(CACHE_KEY_HIERARCHY, "-").concat(projectName));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getAllKeys: function getAllKeys(projectName) {
      return new Promise(function ($return, $error) {
        var cacheKey, cached, response;
        cacheKey = "".concat(CACHE_KEY_KEYS, "-").concat(projectName);
        cached = _cacheGet(cacheKey);

        if (cached) {
          return $return(cached);
        }

        return _fetchJson("/projects/".concat(projectName, "/keys")).then(function ($await_23) {
          response = $await_23;
          return $return(_cacheSet(cacheKey, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    createKeys: function createKeys(projectName, keyList) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys"), {
          method: 'POST',
          body: JSON.stringify({
            keys: keyList
          })
        }).then(function ($await_24) {
          response = $await_24;

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    updateKey: function updateKey(projectName, keyName, keyDefinition) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName), {
          method: 'POST',
          body: JSON.stringify(keyDefinition)
        }).then(function ($await_25) {
          response = $await_25;

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteKey: function deleteKey(projectName, keyName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName), {
          method: 'DELETE'
        }).then(function ($await_26) {
          response = $await_26;

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteKeyMetadata: function deleteKeyMetadata(projectName, keyName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/metadata"), {
          method: 'DELETE'
        }).then(function ($await_27) {
          response = $await_27;

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteKeyMetadataByName: function deleteKeyMetadataByName(projectName, keyName, metadataName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/metadata/").concat(metadataName), {
          method: 'DELETE'
        }).then(function ($await_28) {
          response = $await_28;

          _cacheClearByKey("".concat(CACHE_KEY_KEYS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_STRINGS, "-").concat(projectName));

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createStrings: function createStrings(projectName, localeCode, strings) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode), {
          method: 'POST',
          body: JSON.stringify(strings)
        }).then(function ($await_29) {
          response = $await_29;

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createGoldStrings: function createGoldStrings(projectName, localeCode, strings) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode, "/gold"), {
          method: 'POST',
          body: JSON.stringify(strings)
        }).then(function ($await_30) {
          response = $await_30;

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createStringByKey: function createStringByKey(projectName, keyName, localeCode, string) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/locales/").concat(localeCode), {
          method: 'POST',
          body: JSON.stringify({
            value: string
          })
        }).then(function ($await_31) {
          response = $await_31;

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createGoldStringByKey: function createGoldStringByKey(projectName, keyName, localeCode, string) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/locales/").concat(localeCode, "/gold"), {
          method: 'POST',
          body: JSON.stringify({
            value: string
          })
        }).then(function ($await_32) {
          response = $await_32;

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteStrings: function deleteStrings(projectName, localeCode, body) {
      return new Promise(function ($return, $error) {
        var cacheKey, response;
        cacheKey = "".concat(CACHE_KEY_STRINGS, "-").concat(projectName, "-").concat(localeCode);
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode), {
          method: 'DELETE',
          body: body && JSON.stringify(body) || undefined
        }).then(function ($await_33) {
          response = $await_33;

          _cacheClearByKey(cacheKey);

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteGoldStrings: function deleteGoldStrings(projectName, localeCode) {
      return new Promise(function ($return, $error) {
        var cacheKey, response;
        cacheKey = "".concat(CACHE_KEY_STRINGS, "-").concat(projectName, "-").concat(localeCode, "-gold");
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode, "/gold"), {
          method: 'DELETE'
        }).then(function ($await_34) {
          response = $await_34;

          _cacheClearByKey(cacheKey);

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteStringByKey: function deleteStringByKey(projectName, keyName, localeCode, attributes) {
      return new Promise(function ($return, $error) {
        var response, cacheKey;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/locales/").concat(localeCode), {
          method: 'DELETE',
          body: attributes ? JSON.stringify(attributes) : null
        }).then(function ($await_35) {
          response = $await_35;
          cacheKey = "".concat(CACHE_KEY_STRINGS, "-").concat(projectName, "-").concat(localeCode);

          _cacheClearByKey(cacheKey);

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    deleteGoldStringByKey: function deleteGoldStringByKey(projectName, keyName, localeCode, attributes) {
      return new Promise(function ($return, $error) {
        var response, cacheKey;
        return _fetchJson("/projects/".concat(projectName, "/keys/").concat(keyName, "/locales/").concat(localeCode, "/gold"), {
          method: 'DELETE',
          body: attributes ? JSON.stringify(attributes) : null
        }).then(function ($await_36) {
          response = $await_36;
          cacheKey = "".concat(CACHE_KEY_STRINGS, "-").concat(projectName, "-").concat(localeCode, "-gold");

          _cacheClearByKey(cacheKey);

          _cacheClearByKeyStartsWith("".concat(CACHE_KEY_BUNDLES, ":").concat(projectName.toLowerCase()));

          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getBundle: function getBundle(projectName, locales, keys, withoutFallbacks, doNotExport, returnStringAttributes) {
      return new Promise(function ($return, $error) {
        var cacheId, cachedValue, reqBody, query, response;
        // adding doNotExport flag to bundle endpoint to filter out all the keys whose value is true for doNotExport
        // ( this will go away in future when we handle export in new route )
        locales = [].concat(locales).filter(function (lc) {
          return typeof lc === 'string';
        }).sort();
        keys = [].concat(keys).filter(function (k) {
          return typeof k === 'string';
        }).sort();
        cacheId = [CACHE_KEY_BUNDLES, projectName.toLowerCase(), locales.join(','), keys.join(','), withoutFallbacks === true // omit final item 'gold', to differentiate from identical request for gold copy
        ].join(':');
        cachedValue = _cacheGet(cacheId);

        if (cachedValue) {
          return $return(cachedValue);
        }

        reqBody = {
          locales: locales,
          keys: keys,
          returnStringAttributes: returnStringAttributes
        };
        query = "/bundle/".concat(projectName);

        if (withoutFallbacks !== undefined) {
          query = "".concat(query, "?withoutFallbacks=").concat(withoutFallbacks);
        }

        if (doNotExport !== undefined) {
          query = "".concat(query, "&doNotExport=").concat(doNotExport);
        }

        return _fetchJson(query, {
          method: 'POST',
          body: JSON.stringify(reqBody)
        }).then(function ($await_37) {
          response = $await_37;
          return $return(_cacheSet(cacheId, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    getGoldBundle: function getGoldBundle(projectName, locales, keys, withoutFallbacks, doNotExport, returnStringAttributes) {
      return new Promise(function ($return, $error) {
        var cacheId, cachedValue, reqBody, query, response;
        locales = [].concat(locales).filter(function (lc) {
          return typeof lc === 'string';
        }).sort();
        keys = [].concat(keys).filter(function (k) {
          return typeof k === 'string';
        }).sort(); // adding doNotExport flag to bundle endpoint to filter out all the keys whose value is true for doNotExport
        // ( this will go away in future when we handle export in new route )

        cacheId = [CACHE_KEY_BUNDLES, projectName.toLowerCase(), locales.join(','), keys.join(','), withoutFallbacks === true, 'gold'].join(':');
        cachedValue = _cacheGet(cacheId);

        if (cachedValue) {
          return $return(cachedValue);
        }

        reqBody = {
          locales: locales,
          keys: keys,
          returnStringAttributes: returnStringAttributes
        };
        query = "/bundle/".concat(projectName, "/gold");

        if (withoutFallbacks !== undefined) {
          query = "".concat(query, "?withoutFallbacks=").concat(withoutFallbacks);
        }

        if (doNotExport !== undefined) {
          query = "".concat(query, "&doNotExport=").concat(doNotExport);
        }

        return _fetchJson(query, {
          method: 'POST',
          body: JSON.stringify(reqBody)
        }).then(function ($await_38) {
          response = $await_38;
          return $return(_cacheSet(cacheId, response, CACHE_DURATION_MIN));
        }.$asyncbind(this, $error), $error);
      });
    },
    saveProjectBundle: function saveProjectBundle(bundle, projectName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/bundle/save/".concat(projectName), {
          method: 'POST',
          body: JSON.stringify({
            projectBundle: bundle,
            projectName: projectName
          })
        }).then(function ($await_39) {
          response = $await_39;
          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    saveGoldProjectBundle: function saveGoldProjectBundle(bundle, projectName) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson("/bundle/save/".concat(projectName, "/gold"), {
          method: 'POST',
          body: JSON.string({
            projectBundle: bundle,
            projectName: projectName
          })
        }).then(function ($await_40) {
          response = $await_40;
          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    createContent: function createContent(templateId, contentItemId, content) {
      return new Promise(function ($return, $error) {
        var response;
        return _fetchJson('/contents', {
          method: 'POST',
          body: JSON.stringify({
            templateId: templateId,
            contentItemId: contentItemId,
            content: content
          })
        }).then(function ($await_41) {
          response = $await_41;
          return $return(response);
        }.$asyncbind(this, $error), $error);
      });
    },
    getContentByContentItemId: function getContentByContentItemId(contentItemId) {
      return new Promise(function ($return, $error) {
        return _fetchJson("/contents?contentItemId=".concat(contentItemId)).then($return, $error);
      });
    },
    getContentByRevision: function getContentByRevision(contentItemId, revision) {
      return new Promise(function ($return, $error) {
        return _fetchJson("/contents?contentItemId=".concat(contentItemId, "&revision=").concat(revision)).then($return, $error);
      });
    },
    getStringsWithAttributesAndHierarchy: function getStringsWithAttributesAndHierarchy(projectName, localeCode, keys, attributes) {
      return new Promise(function ($return, $error) {
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode, "/attributes/hierarchy"), {
          method: 'POST',
          body: JSON.stringify({
            keys: keys,
            attributes: attributes
          })
        }).then($return, $error);
      });
    },
    getStringsWithAttributes: function getStringsWithAttributes(projectName, localeCode, keys) {
      return new Promise(function ($return, $error) {
        return _fetchJson("/projects/".concat(projectName, "/locales/").concat(localeCode, "/attributes"), {
          method: 'POST',
          body: JSON.stringify({
            keys: keys
          })
        }).then($return, $error);
      });
    }
  };
}

var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  clearByKey: function clearByKey() {
    return undefined;
  },
  clearByKeyStartsWith: function clearByKeyStartsWith() {
    return undefined;
  }
};

module.exports = function (url, customFetch, cacheInterface, companyId) {
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  } // only rely on the injected cacheImplementation if it provides ALL the methods our own noCache provides


  if (!cacheInterface) {
    cacheInterface = noCache;
  } else {
    var missingMethod = Object.keys(noCache).find(function (methodName) {
      return typeof cacheInterface[methodName] !== 'function';
    });

    if (missingMethod) {
      console.log("@nackle/cmx-sdk cannot use the provided cacheImplementation because it does not have method \"".concat(missingMethod, "\""));
      cacheInterface = noCache;
    }
  }

  return new SDK(url, customFetch, cacheInterface, companyId);
};
//# sourceMappingURL=index.js.map